import { Component } from '@angular/core';
import { ADBInfo, DBPanelInfo } from '../../../../../models/datamodel/adbinfo.model';
import { BaseDataSourcePanel } from '../../../../../settings/datamodel/datasource/datasourcepanels/basedatasource.panel';

@Component({
    selector: 'oracledb-panel',
    templateUrl: './oracledb.panel.html',
    styleUrls: ['./oracledb.panel.css']
})
export class OracleDBPanel extends BaseDataSourcePanel {
    constructor() {
        super();
        this.DBInfoType = OracleDBInfo;
    }

    static GetInfo(): DBPanelInfo {
        return {
            ControlType: OracleDBPanel,
            DBInfoType: OracleDBInfo
        };
    }
}

export class OracleDBInfo extends ADBInfo {
    Server: string;
    Port = 1521;
    Database: string;
    Username: string;
    Password: string;
    SSPI = false;
    Timeout = 30;
    //HasConnectionString = true;
    //ConnectionString: string;

    getTypeName(): string {
        return 'evidanza.Database.Oracle.OracleDBInfo';
    }
}